import { DefectAnnotation } from '@skinsoft/entity';
import { MediaTransferHelper } from '@skinsoft/media-transfer-helper';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { createTranslatedString } from '@skinsoft/ui';
import { FormApi } from 'final-form';
import { map, set } from 'lodash';
import { first } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { DELETE_IMAGE_CLICK_TOPIC, DRAWING_MODIFICATION_TOPIC, IMAGE_CLICK_TOPIC, IMAGE_UPLOADED_TOPIC, OPEN_DRAWING_EDITOR_TOPIC, SAVE_CURRENT_REPORT_TOPIC } from '../../../../busTopics';
import { MediaArea } from '../../fields-areas/medias-area';

@Component({
    components: {
        sMediaArea: MediaArea
    },
    props: ['fieldName', 'annotations', 'form', 'breadcrumbObject'],
    template: require('./defect-annotations-view.html')
})
export class DefectAnnotationsView extends ReactiveVue {

    public fieldName: string;
    public form: FormApi;
    public annotations: DefectAnnotation[];
    public breadcrumbObject: any;

    private annotationMediasIds: string[] = [];
    private $mediaTransferHelper: MediaTransferHelper;

    public mounted() {
        // Listening to id changes from cache after backend operations
        this.$on('id-changed-from-cache', (message) => {
            this.updateAnnotationMediaFromCacheChange(message.oldMediaId, message.newMediaId);
        })
    }

    public subscribe() {
        this.annotationMediasIds = !!this.annotations ? map(this.annotations, 'media') : [];
        // Updating form values when drawing-editor is exited
        this.subscribeToBus(DRAWING_MODIFICATION_TOPIC, (message) => {
            if (message.payload.annotationFieldName.includes(this.fieldName)) {
                // Update shapes
                set(this.form.getState().values, this.svgFieldName(message.payload.annotationListFieldIndex), message.payload.svg)
                // Update observations
                set(this.form.getState().values, this.observationFieldName(message.payload.annotationListFieldIndex), message.payload.observations)
            }
        })
        this.$on(IMAGE_CLICK_TOPIC, (event) => this.onImageClick(event))
        this.$on(DELETE_IMAGE_CLICK_TOPIC, (event) => this.onImageDeleteClick(event))
        this.$on(IMAGE_UPLOADED_TOPIC, (fileData) => this.onImageUploaded(fileData))
    }

    public svgFieldName(index) {
        return `${this.fieldName}[${index}.svg`;
    }

    public observationFieldName(index) {
        return `${this.fieldName}[${index}.comments`;
    }

    public onImageClick(event) {
        this.emitOnBus(OPEN_DRAWING_EDITOR_TOPIC, {
            annotation: this.annotations[event.imageListIndex],
            annotationListFieldIndex: event.imageListIndex,
            annotationListFieldName: `${this.fieldName}`,
            breadcrumbObject: this.breadcrumbObject,
            mediaId: event.id
        })
    }

    public onImageDeleteClick(event) {
        this.annotations.splice(event.imageListIndex, 1)
    }

    public onImageUploaded(fileData) {
        this.uploadMedia(fileData)
    }

    public beforeDestroy() {
        this.unsubscribe()
    }

    private uploadMedia(fileData) {
        const formData = new FormData();
        formData.append("file", fileData.file)

        // Retrieving temp id and uploading the media on backend asynchronously
        const tempMediaId = this.$mediaTransferHelper.uploadMedia(fileData.file.type, fileData.file, fileData.url);
        const newAnnotation: DefectAnnotation = {
            comments: [],
            id: 0, // useful for key-generation in v-for display but not in api so we set 0 
            media: tempMediaId, // Retrieving temp id corresponding to cache, while the real id is generated from backend
            svg: "[]",
            title: createTranslatedString(this.$i18n.locale)
        }
        this.annotations.push(newAnnotation)
        this.emitOnBus(OPEN_DRAWING_EDITOR_TOPIC, { annotation: newAnnotation, annotationListFieldName: this.fieldName, annotationListFieldIndex: this.annotations.length - 1, mediaUrl: fileData.url, breadcrumbObject: this.breadcrumbObject })

        this.form.submit();
    }

    private updateAnnotationMediaFromCacheChange(oldMediaId, newMediaId) {
        this.annotations.map(
            (annotation) => {
                if (annotation.media === oldMediaId) {
                    annotation.media = newMediaId;
                }
            }
        )

        // save report to keep modifications
        this.form.submit();
    }

    private unsubscribe() {
        this.$off(IMAGE_UPLOADED_TOPIC)
        this.$off(DELETE_IMAGE_CLICK_TOPIC)
        this.$off(IMAGE_CLICK_TOPIC)
    }

    @Watch('annotations', { immediate: true })
    private onAnnotationsChange() {
        this.unsubscribe();
        this.subscribe();
    }



}